import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Paper } from '@mui/material';
import CircularChart from './CircularChart';
import { api as axios } from '../../api';
import url from '../../serverUrl';
import LineCharts from '../Graphs/LineChart';
function DashboardContent({ user }) {
  const [currentValue, setCurrentValue] = React.useState(0);
  const get_current_index_coin = () => {
    axios
      .get(`${url}/wallet/get_current_index_coin`)
      .then((res) => {
        setCurrentValue(res.data[0].value);
      })
      .catch((err) => {
        // console.log(err);
      });
  };

  React.useEffect(() => {
    get_current_index_coin();
  }, [user]);
  return (
    <>
      <Box
        className="rounded shadow"
        sx={{
          padding: 1,
          width: '95%',
          ml: '2.5%',
          mt: 1,
          pb: 2
        }}
      >
        <Grid container spacing={5} sx={{ textTransform: 'uppercase', p: 5 }}>
          <Grid item xs={12} md={6} lg={3} mt={5}>
            {/* dashboard left */}
            <Grid sx={{ mt: 3 }}>
              <Paper
                style={{
                  textAlign: 'center',
                  backgroundColor: '#00071a'
                }}
                className="border"
              >
                <div
                  style={{
                    color: 'white',
                    wordWrap: 'break-word'
                  }}
                >
                  <div
                    className="rounded center-width tUpper"
                    style={{ backgroundColor: '#002945' }}
                  >
                    <h3>Total XMG</h3>
                  </div>
                  <p className="fontS22">3 B</p>
                </div>
              </Paper>
            </Grid>
            <Grid sx={{ mt: 3 }}>
              <Paper
                style={{
                  textAlign: 'center',
                  backgroundColor: '#00071a'
                }}
                className="border"
              >
                <div
                  style={{
                    color: 'white',
                    wordWrap: 'break-word'
                  }}
                >
                  <div
                    className="rounded center-width tUpper"
                    style={{ backgroundColor: '#002945' }}
                  >
                    <h3>Total Value</h3>
                  </div>
                  <p className="fontS22">$3 B</p>
                </div>
              </Paper>
            </Grid>
            <Grid sx={{ mt: 3 }}>
              <Paper
                style={{
                  textAlign: 'center',
                  backgroundColor: '#00071a'
                }}
                className="border"
              >
                <div
                  style={{
                    color: 'white',
                    wordWrap: 'break-word'
                  }}
                >
                  <div
                    className="rounded center-width tUpper"
                    style={{ backgroundColor: '#002945' }}
                  >
                    <h3>Total Coin</h3>
                  </div>
                  <p className="fontS22">3B</p>
                </div>
              </Paper>
            </Grid>
          </Grid>
          {/* dashboard middle */}
          <CircularChart />
          {/* dashboard right */}
          <Grid item xs={12} md={8} lg={3} mt={5}>
            <Grid sx={{ mt: 3 }}>
              <Paper
                style={{
                  textAlign: 'center',
                  backgroundColor: '#00071a'
                }}
                className="border"
              >
                <div
                  style={{
                    color: 'white',
                    wordWrap: 'break-word'
                  }}
                >
                  <div
                    className="rounded center-width tUpper"
                    style={{ backgroundColor: '#002945' }}
                  >
                    <h3>Total PECU</h3>
                  </div>
                  <p className="fontS22">3B</p>
                </div>
              </Paper>
            </Grid>
            <Grid sx={{ mt: 3 }}>
              <Paper
                style={{
                  textAlign: 'center',
                  backgroundColor: '#00071a'
                }}
                className="border"
              >
                <div
                  style={{
                    color: 'white',
                    wordWrap: 'break-word'
                  }}
                >
                  <div
                    className="rounded center-width tUpper"
                    style={{ backgroundColor: '#002945' }}
                  >
                    <h3>Total Value</h3>
                  </div>
                  <p className="fontS22">3 B</p>
                </div>
              </Paper>
            </Grid>
            <Grid sx={{ mt: 3 }}>
              <Paper
                style={{
                  textAlign: 'center',
                  backgroundColor: '#00071a'
                }}
                className="border"
              >
                <div
                  style={{
                    color: 'white',
                    wordWrap: 'break-word'
                  }}
                >
                  <div
                    className="rounded center-width tUpper"
                    style={{ backgroundColor: '#002945' }}
                  >
                    <h3>Total Pecu Coin</h3>
                  </div>
                  <p className="fontS22">3 B</p>
                </div>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      {/* second row */}
      <Box
        className="rounded shadow"
        sx={{
          padding: 1,
          width: '95%',
          ml: '2.5%',
          mt: 3,
          mb: 1
        }}
      >
        <LineCharts />
      </Box>
      {/* Third row */}
      <Box
        className="rounded shadow"
        sx={{
          padding: 1,
          width: '95%',
          ml: '2.5%',
          mt: 3,
          backgroundColor: 'black',
          mb: 1
        }}
      >
        <Grid container spacing={5} sx={{ p: 1 }}>
          <Grid item xs={12} md={6} lg={4} xl={3}>
            <Paper
              style={{
                textAlign: 'center',
                backgroundColor: '#00071a'
              }}
              className="border "
            >
              <div
                style={{
                  color: 'white',
                  wordWrap: 'break-word'
                }}
              >
                <div
                  className="rounded center-width tUpper"
                  style={{ backgroundColor: '#002945' }}
                >
                  <h3>Current Pool Balance</h3>
                </div>
                <p className="fontS22">6B</p>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} lg={4} xl={3}>
            <Paper
              style={{
                textAlign: 'center',
                backgroundColor: '#00071a'
              }}
              className="border"
            >
              <div
                style={{
                  color: 'white',
                  wordWrap: 'break-word'
                }}
              >
                <div
                  className="rounded center-width tUpper"
                  style={{ backgroundColor: '#002945' }}
                >
                  <h3>Current PECU Price</h3>
                </div>
                <p className="fontS22">${currentValue}</p>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6} lg={4} xl={3}>
            <Paper
              style={{
                textAlign: 'center',
                backgroundColor: '#00071a'
              }}
              className="border"
            >
              <div
                style={{
                  color: 'white',
                  wordWrap: 'break-word'
                }}
              >
                <div
                  className="rounded center-width tUpper"
                  style={{ backgroundColor: '#002945' }}
                >
                  <h3>Current XMG Price</h3>
                </div>
                <p className="fontS22">$ 1</p>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default function Tier0Dashboard({ user }) {
  return <DashboardContent user={user} />;
}
